export default __webpack_public_path__ + "static/media/04.d79a92fb.webp";